/** Mirrors `functions/src/organizations/orgRoles.js`. */
export const USER_ORG_ROLE = {
  ADMIN: "admin",
  MEMBER: "member",
  TEACHER: "teacher",
  OBSERVER: "observer",
  MARKETING_EXECUTIVE: "marketingExecutive",
};

/** users.role value used so a dedicated Marketing Executive can land on the ads dashboard. */
export const USERS_ROLE_MARKETING_EXECUTIVE = "marketingExecutive";

/** users.role for the Caremap2 city CPM “Brought to you by” auction. */
export const USERS_ROLE_BTYB_MARKETER = "btybMarketer";

export function isMarketingExecutiveUser(userData) {
  return (
    userData?.role === USERS_ROLE_MARKETING_EXECUTIVE ||
    userData?.activeOrgRole?.role === USER_ORG_ROLE.MARKETING_EXECUTIVE
  );
}

export function isBtybMarketerUser(userData) {
  return userData?.role === USERS_ROLE_BTYB_MARKETER;
}

export function canManageZipSlotAds({ userData, isGlobalAdmin } = {}) {
  if (isGlobalAdmin) return true;
  if (userData?.role === USER_ORG_ROLE.ADMIN) return true;
  if (userData?.role === USERS_ROLE_MARKETING_EXECUTIVE) return true;
  const orgRole = userData?.activeOrgRole?.role;
  return (
    orgRole === USER_ORG_ROLE.ADMIN ||
    orgRole === USER_ORG_ROLE.MARKETING_EXECUTIVE
  );
}
